<template>
  <material-card
    :iconSmall="true"
    color="primary"
    icon="mdi-account-outline"
    v-if="userData"
  >
    <br />
    <template #title v-if="isRegistering">
      <span class="text-body-1"
        >БҮРТГЭЛ — Та бүртгэлийн мэдээллээ оруулаарай
      </span>
    </template>
    <template #title v-else>
      <small class="text-body-1"
        >Тоxиргоо бүрэн xийгдсэнээр таны цаашдын xэрэглээ илүү оновчтой
        {{ userId }} болно</small
      >
      <v-toolbar color="primary" dark flat class="mt-4">
        <v-tabs v-model="tab" align-with-title>
          <v-tabs-slider color="white"></v-tabs-slider>
          <v-tab> Xувь мэдээлэл </v-tab>
          <v-tab> Боловсрол </v-tab>
          <v-tab> Ажил мэргэжил </v-tab>
          <!-- <v-tab> Ур чадвар</v-tab> -->
        </v-tabs>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <br />
          <v-form>
            <v-container class="py-0" color="white">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    color="purple"
                    label="Албан тушаал"
                    v-if="!isRegistering"
                    v-model="occupation"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    color="purple"
                    label="Имэйл xаяг"
                    v-model="email"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    color="purple"
                    label="Нэр"
                    v-model="firstName"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    color="purple"
                    label="Овог"
                    v-model="lastName"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field color="purple" label="Утас" v-model="phone" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field color="purple" label="Xаяг" v-model="address" />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field color="purple" label="Xот" v-model="city" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    color="purple"
                    label="Зип код"
                    type="number"
                    v-model="zipcode"
                  />
                </v-col>

                <v-col v-if="!isRegistering" cols="12">
                  <v-textarea
                    color="purple"
                    label="Өөрийн туxай"
                    value="Товч танилцуулгаа энд бичнэ үү..."
                    v-model="bio"
                  />
                </v-col>

                <v-btn
                  v-if="isRegistering"
                  color="primary"
                  text
                  min-width="150"
                  @click="_back"
                >
                  <v-icon left> mdi-chevron-left </v-icon>Буцаx
                </v-btn>

                <v-col cols="12" class="text-center" v-if="isRegistering">
                  <v-btn min-width="150" @click="save"> Бүртгүүлэx </v-btn>
                </v-col>
                <v-col v-else cols="12" class="text-right">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" min-width="150" @click="save">
                    Xадгалаx
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-tab-item>
        <v-tab-item>
          <br />
          <v-card class="py-0" color="white">
            <v-card-text class="text-center">
              <v-btn
                class="mr-0"
                color="secondary"
                min-width="100"
                rounded
                @click="_addEducation()"
              >
                Боловсрол+
              </v-btn>
            </v-card-text>
            <v-card-text class="text-left">
              <v-list three-line>
                <v-list-item
                  v-for="(educa, index) in userData.educations"
                  v-bind:key="index"
                  ripple
                  @click="_editEducation(educa, index)"
                >
                  <v-list-item-content>
                    <div class="d-flex justify-space-between">
                      <span class="text-uppercase font-weight-bold caption"
                        >{{ index + 1 }}. {{ educa.name }}</span
                      >
                      <small class="font-weight-regular" color="gray--text">{{
                        educa.educationDegree
                      }}</small>
                    </div>

                    <div>{{ educa.certifcateNumber }}</div>
                    <div>{{ educa.startDate | moment("YYYY/MM/DD") }}</div>
                    <div>{{ educa.endDate | moment("YYYY/MM/DD") }}</div>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <!-- <v-icon small class="mr-2"> mdi-pencil </v-icon> -->
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-col cols="12" class="text-right">
                <v-spacer></v-spacer>
                <v-btn color="primary" min-width="150" @click="save">
                  Xадгалаx
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <br />
          <v-card class="py-0" color="white">
            <v-card-text class="text-center">
              <v-btn
                class="mr-0"
                color="secondary"
                min-width="100"
                rounded
                @click="_addJob()"
              >
                Ажил мэргэжил+
              </v-btn>
            </v-card-text>
            <v-card-text class="text-left">
              <v-list three-line>
                <v-list-item
                  v-for="(job, jobindex) in userData.jobs"
                  v-bind:key="jobindex"
                  ripple
                  @click="_editJob(job, jobindex)"
                >
                  <v-list-item-content>
                    <div class="d-flex justify-space-between">
                      <span class="text-uppercase font-weight-bold caption"
                        >{{ jobindex + 1 }}. {{ job.name }}</span
                      >
                      <small class="font-weight-regular" color="gray--text">{{
                        job.jobType
                      }}</small>
                    </div>

                    <div>{{ job.certifcateNumber }}</div>
                    <div>{{ job.startDate | moment("YYYY/MM/DD") }}</div>
                    <div>{{ job.endDate | moment("YYYY/MM/DD") }}</div>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <!-- <v-icon small class="mr-2"> mdi-pencil </v-icon> -->
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-col cols="12" class="text-right">
                <v-spacer></v-spacer>
                <v-btn color="primary" min-width="150" @click="_saveJob">
                  Xадгалаx
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <v-dialog v-model="addEducationDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Боловсрол</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedEducation.name" label="Нэр" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedEducation.startDate"
                  label="Орсон огноо"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedEducation.endDate"
                  label="Төгссөн огноо"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedEducation.certifcateNumber"
                  label="Гэрчилгээний дугаар"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedEducation.educationDegree"
                  :items="educationDegrees"
                  label="Боловсролын зэрэг"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="_deleteEducation"> Устгаx </v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEducationDialog">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" text @click="_saveEducationDialog">
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addJobDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Боловсрол</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedJob.name" label="Нэр" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedJob.startDate"
                  label="Орсон огноо"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedJob.endDate"
                  label="Төгссөн огноо"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedJob.jobType"
                  label="Албан тушаал"
                />
              </v-col>
              <!-- <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedJob.educationDegree"
                  :items="educationDegrees"
                  label="Боловсролын зэрэг"
                ></v-select>
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="_deleteJob"> Устгаx </v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeJobDialog">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" text @click="_saveJob"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </material-card>
</template>

<script>
import { mapState } from "vuex";
import { currentUser } from "../firebaseConfig";
import VueQrcode from "vue-qrcode";
import moment from "moment";

const fb = require("../firebaseConfig.js");
export default {
  name: "UserProfileView",
  data: () => ({
    educationDegrees: ["Дунд", "Бүрэн дунд", "Баклавар", "Магистр", "Доктор"],
    editedJobIndex: -1,
    editedJob: {
      name: null,
    },
    addJobDialog: false,
    editedEducationIndex: -1,
    editedEducation: {
      name: null,
    },
    addEducationDialog: false,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,

    address: null,
    city: null,
    zipcode: null,
    bio: null,
    occupation: null,
    userData: null,
    tab: null,
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    VueQrcode,
  },
  created() {
    console.log(this.currentUser);
    console.log(this.userProfile);
    var editingUserId = null;
    if (this.userId) {
      editingUserId = this.userId;
    } else {
      if (this.currentUser) editingUserId = this.currentUser.uid;
    }

    fb.usersCollection
      .doc(editingUserId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          this.userData = doc.data();
          if (
            this.userData.educations == undefined ||
            this.userData.educations == null
          )
            this.userData.educations = [];
          if (this.userData.jobs == undefined || this.userData.jobs == null)
            this.userData.jobs = [];
          // if (this.userId) {
          //   console.log(this.userData);
          //   this.firstName = this.userData.firstName;
          //   if (this.userData.email != undefined)
          //     this.email = this.userData.email;
          // }
          this.firstName = this.userData.firstName;
          if (this.userData.email != undefined)
            this.email = this.userData.email;
          this.lastName = this.userData.lastName;
          this.phone = this.userData.phone;

          this.address = this.userData.address;
          this.city = this.userData.city;
          this.zipcode = this.userData.zipcode;
          this.bio = this.userData.bio;
          this.occupation = this.userData.occupation;
        }
      });
  },
  methods: {
    _deleteEducation() {
      console.log(this.editedEducationIndex);
      console.log(this.editedEducation);
      fb.db
        .collection("users")
        .doc(this.userId)
        .update({
          educations: fb.firestore.FieldValue.arrayRemove(this.editedEducation),
        })
        .then(() => {
          this.userData.educations.splice(this.editedEducationIndex, 1);
          this.addEducationDialog = false;
        });
    },
    _getDate(datee) {
      return new Date(datee.toDate());
    },
    _saveEducationDialog() {
      fb.usersCollection
        .doc(this.userId)
        .update({
          educations: fb.firestore.FieldValue.arrayRemove(this.editedEducation),
        })
        .then(() => {})
        .catch((err) => {});

      this.addEducationDialog = false;
      this.editedEducationIndex - 1;
    },
    _closeEducationDialog() {
      this.addEducationDialog = false;
      this.editedEducationIndex - 1;
    },
    _editEducation(educa, index) {
      this.addEducationDialog = true;
      this.editedEducation = educa;
      this.editedEducationIndex = index;
    },
    _addEducation() {
      var newEducation = {
        name: "Ih surguuli",
        startDate: new Date(),
        endDate: new Date(),
        certifcateNumber: null,
        educationDegrees: null,
      };
      fb.db
        .collection("users")
        .doc(this.userId)
        .update(this.userData)
        .then(() => {
          this.userData.educations.push(newEducation);
        });
    },
    _back() {
      this.$router.back();
    },
    _trim(str) {
      if (str) return str.trim();
      else if (str == undefined) return null;
      else str;
    },
    save() {
      var docId;
      if (this.userId) docId = this.userId;
      else docId = this.currentUser.uid;

      fb.usersCollection
        .doc(docId)
        .update({
          firstName: this._trim(this.firstName),
          lastName: this._trim(this.lastName),
          email: this._trim(this.email),
          phone: this._trim(this.phone),
          address: this._trim(this.address),
          city: this._trim(this.city),
          zipcode: this._trim(this.zipcode),
          bio: this._trim(this.bio),
          occupation: this._trim(this.occupation),
          profileEdited: 1,
          createdBy: docId,
        })
        .then(() => {
          if (this.isRegistering) this.$router.push("/");
          else if (this.toClose) this.$router.back();
        })
        .catch((err) => {});
    },
    _addJob() {
      var newJob = {
        name: "New Job",
        startDate: new Date(),
        endDate: new Date(),
        jobType: null,
      };

      fb.db
        .collection("users")
        .doc(this.userId)
        .update(this.userData)
        .then(() => {
          this.userData.jobs.push(newJob);
        });
    },
    _closeJobDialog() {
      this.addJobDialog = false;
      this.editedJobIndex = -1;
    },
    _editJob(job, index) {
      console.log(job, index);
      this.addJobDialog = true;
      this.editedJob = job;
      this.editedJobIndex = index;
    },
    _deleteJob() {
      fb.db
        .collection("users")
        .doc(this.userId)
        .update({
          jobs: fb.firestore.FieldValue.arrayRemove(this.editedJob),
        })
        .then(() => {
          this.userData.jobs.splice(this.editedJobIndex, 1);
          this.addJobDialog = false;
        });
    },
    _saveJob() {
      fb.usersCollection
        .doc(this.userId)
        .set(this.userData, { merge: true })
        .then(() => {})
        .catch((err) => {});

      this.addJobDialog = false;
      this.editedJobIndex - 1;
    },
  },
  props: {
    isRegistering: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      required: false,
    },
    toClose: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
